const W = 640;
const H = 140;

export const BarChart = ({ data, valueKey, label, testId, color = "hsl(46 65% 52%)" }) => {
  const max = Math.max(1, ...data.map((d) => d[valueKey]));
  const bw = W / data.length;
  return (
    <div data-testid={testId}>
      <p className="mb-2 font-mono-ui text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</p>
      <svg viewBox={`0 0 ${W} ${H + 18}`} className="w-full">
        {data.map((d, i) => {
          const h = (d[valueKey] / max) * H;
          return (
            <g key={d.day}>
              <rect x={i * bw + 2} y={H - h} width={bw - 4} height={h} fill={color} rx="1"><title>{`${d.day}: ${d[valueKey]}`}</title></rect>
              {i % 5 === 0 && <text x={i * bw + 2} y={H + 14} fontSize="9" fill="hsl(218 11% 65%)">{d.day.slice(5)}</text>}
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export const HBars = ({ rows, label, testId }) => {
  const max = Math.max(1, ...rows.map((r) => r.value));
  return (
    <div data-testid={testId}>
      <p className="mb-3 font-mono-ui text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</p>
      {!rows.length && <p className="text-sm text-muted-foreground">No data yet.</p>}
      {rows.map((r) => (
        <div key={r.key} className="mb-2">
          <div className="flex justify-between text-xs"><span>{r.key}</span><span className="text-muted-foreground">{r.text}</span></div>
          <div className="mt-1 h-2 rounded bg-secondary"><div className="h-2 rounded bg-primary" style={{ width: `${(r.value / max) * 100}%` }} /></div>
        </div>
      ))}
    </div>
  );
};
